import { InputBase, alpha, Autocomplete, TextField } from '@mui/material';
import { connect } from 'redux-bundler-react';
import PropTypes from 'prop-types';
import React from 'react';
import matchSorter from 'match-sorter';
import { withStyles } from 'tss-react/mui';

import Recipe from '../../../models/group';

const styles = theme => ({
  inputBase: {
    width: '100%',
    '& input': {
      borderRadius: 4,
      backgroundColor: theme.palette.background.default,
      padding: 8,
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      border: '1px solid #ced4da',
      fontSize: 14,
      '&:focus': {
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
        borderColor: theme.palette.primary.main,
      },
    },
  },
});

const filterOptions = (options, { inputValue }) => {
  return matchSorter(options, inputValue);
};

const ArchRecipeChipInput = ({
  value,
  onChange,
  renderInput,
  chefPackage,
  classes,
  disablePortal = false,
  ...rest
}) => {
  const [inputValue, setInputValue] = React.useState('');
  const handleChange = event => {
    setInputValue(event.target.value);
  };
  return (
    <Autocomplete
      disablePortal={disablePortal}
      slotProps={{
        popper: {
          style: {
            zIndex: 99999,
          },
          placement: 'bottom-start',
        },
      }}
      filterOptions={filterOptions}
      options={[
        ...chefPackage.cookbooks
          .map(c => c.recipes)
          .flat()
          .map(r => r.fullname),
        'reboot',
      ]}
      filterSelectedOptions
      renderInput={params => (
        <InputBase
          {...params}
          {...rest}
          ref={params.InputProps.ref}
          inputProps={{ ...params.inputProps, value: inputValue }}
          className={classes.inputBase}
          placeholder="Search for recipes"
          onChange={handleChange}
        />
      )}
      onChange={(e, v) => {
        onChange(v);
        setInputValue('');
      }}
    />
  );
};

ArchRecipeChipInput.propTypes = {
  groupData: PropTypes.arrayOf(Recipe).isRequired,
  value: PropTypes.arrayOf(Recipe).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(ArchRecipeChipInput, styles);
